import Auth from '../api/auth';

const parseErrorCode = error => Promise.reject(error);

export default axios => {
  const { apiHost = '' } = window.manysendsConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  wootApi.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      if (
        error.response?.status === 402 &&
        error.response.data?.requires_subscription &&
        !window.location.href.includes('settings/subscription')
      ) {
        window.location.href = error.response.data.redirect_to;
      }
      parseErrorCode(error);

      return Promise.reject(error);
    }
  );
  return wootApi;
};
